// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Y1v06","languageButton":"styles_languageButton__NvCZu"};